import Link from 'next/link';
import styles from './healthcare.module.css';

import HealthcareIntro from './healthcare-intro';
import HealthcareProblem from './healthcare-problem';
import HealthcareCase1 from './healthcare-case1';
import HealthcareCase2 from './healthcare-case2';
import HealthcareCase3 from './healthcare-case3';

export default function Healthcare() {
  return (
    <div className={styles.content}>
      <HealthcareIntro />
      <div className={styles.healthCaseFlex}>
        <Link href="/contact" passHref prefetch={false}>
          <a className={styles.healthCaseBtn}>Get a consultation</a>
        </Link>
      </div>
      <HealthcareProblem />
      <HealthcareCase1 />
      <HealthcareCase2 />
      <HealthcareCase3 />
    </div>
  );
}
